import React from 'react';
import { SearchItem } from '../types/research';

interface SearchPlanProps {
  searchPlan: SearchItem[];
  isVisible: boolean;
}

const SearchPlan: React.FC<SearchPlanProps> = ({ searchPlan, isVisible }) => {
  if (!isVisible || searchPlan.length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-4xl mx-auto mb-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <span className="mr-2">🧠</span>
            Search Plan ({searchPlan.length} searches)
          </h3>
        </div>
        <div className="divide-y divide-gray-200">
          {searchPlan.map((search, index) => (
            <div key={index} className="px-6 py-4">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-semibold text-sm">{index + 1}</span>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="mb-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      🔍 Search Query
                    </span>
                  </div>
                  <p className="text-sm font-medium text-gray-900 mb-2">
                    "{search.query}"
                  </p>
                  <div className="mb-1">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      💡 Reason
                    </span>
                  </div>
                  <p className="text-sm text-gray-600">
                    {search.reason}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchPlan; 